import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "band" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "letter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.displaySlider)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "highlighted" }, null, -1)),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "slider" }, null, -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.letter), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}